import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (filterLabels: Readonly<Record<string, string>>) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Dashboard Filters',
    display: `Filter header with ${Object.keys(filterLabels).join(
      ', ',
    )} selects. Every figure on the page is scoped to the students matching these filters. Check the value of each filter here: any filter whose value is not All is an applied filter — even when the value reads like a program or group name, it is a selection, never the default scope. When asked about the students shown, name every applied filter with its value; only say no filters are applied when every filter is All.`,
    data: filterLabels,
  });
};
